
<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>{{ (panduan) ? panduan.judul_berita : '' }}</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <router-link to="/home">
                Home
              </router-link>
            </div>
            <div class="breadcrumb-item">
              <router-link to="/panduan">
                Panduan
              </router-link>
            </div>
            <div class="breadcrumb-item">
              {{ (panduan) ? panduan.judul_berita : 'Panduan' }}
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="col-lg-8 offset-lg-2 p-0">
            <div class="mb-3">
              <button
                @click="$router.push({path: '/panduan'})"
                class="btn btn-danger"
              >
                <i class="fa fa-angle-left mr-2" />Kembali
              </button>
            </div>
            <div
              class="card"
              v-if="panduan"
            >
              <div class="card-body">
                <h4 class="panduan-title">
                  {{ panduan.judul_berita }}
                </h4>
                <p>
                  <small>
                    Ditulis oleh {{ panduan.penulis.penduduk.nama_lengkap }},
                    Pada {{ panduan.created_at }}
                  </small>
                </p>
                <hr>
                <div
                  class="panduan-content"
                  v-html="panduan.konten_berita"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<style scoped>
h4.panduan-title {
	color: #34395e; font-weight: normal
}
.panduan-content {
	color: #000;
}
.panduan-content p img {
	max-width: 100%;
}
</style>
<script>
import LayoutAdmin from './../layouts/Admin.vue'

export default {
	name: 'App',
	data(){
        return {
            panduan: null
        }
	},
	computed: {
		profile(){
			return this.$store.getters.getUserProfile
		}
	},
	components: {
		LayoutAdmin
	},
	methods: {
        showPanduan(){
			this.$store.dispatch('showPanduan', this.$route.params.slug).then(res => {
				if(res.data.data){
					let show = res.data.data
					let date = new Date(show.created_at)
					let created_at = date.toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'})
					created_at += ' ' + date.toLocaleTimeString('it-IT')
					show.created_at = created_at
					
					this.panduan = show

					// agak delay v-html nya
					setTimeout(() => {
						this.setImgContent()
					}, 500)
					
				}
			})
		},
		setImgContent(){
			let img = document.querySelectorAll('.panduan-content img')

			img.forEach(e => {
				e.style.maxWidth = '100%'
			})
		}
	},
	mounted(){
		document.querySelector('title').innerHTML = this.$store.getters.getAppName + ' | Penduduk'
	},
	created(){
		this.showPanduan()
	}
}
</script>

<style>

</style>
